var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCroupier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-doctors:not(.animated) .animable {opacity: 0;}svg#freepik_stories-doctors.animated #freepik--background-simple--inject-38 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "232.774px 227.356px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M49.74,251.81C26.29,333.47,178.13,372,259.27,360.1c102.65-15,160.51-71,158.94-157.25-1.55-85.46-97.86-134.42-170.42-98.39-35.76,17.76-61.95,50-97.62,68.44C107.83,194.85,64.39,200.78,49.74,251.81Z",
    fill: "#16A085",
    style: {
      transformOrigin: "232.774px 227.356px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M49.74,251.81C26.29,333.47,178.13,372,259.27,360.1c102.65-15,160.51-71,158.94-157.25-1.55-85.46-97.86-134.42-170.42-98.39-35.76,17.76-61.95,50-97.62,68.44C107.83,194.85,64.39,200.78,49.74,251.81Z",
    fill: "#fff",
    opacity: 0.9,
    style: {
      transformOrigin: "232.774px 227.356px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable animator-hidden",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    fill: "#f5f5f5",
    style: {
      transformOrigin: "250px 416.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "162.153px 253.29px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M164,101.38c-7.55-7.09-20-8.45-24.66-1.07s-2,15.18-11.56,23.36c-6.5,5.59-1.68,22.72,35.4,21.15,17.55-.74,11.61-19,11.14-27.63S173.82,98,164,101.38Z",
    fill: "#263238",
    style: {
      transformOrigin: "150.503px 120.151px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "149.39 402.42 140.41 402.77 140.24 393.05 149.22 392.7",
    fill: "#b55b52",
    style: {
      transformOrigin: "144.815px 397.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M139.85,400.91H150a.78.78,0,0,1,.77.61l1.76,8.05a1.34,1.34,0,0,1-1.33,1.61c-3.55-.06-5.27-.27-9.74-.27-2.75,0-9.88.29-13.68.29s-4.28-3.76-2.73-4.1c7-1.53,11.07-3.63,13.31-5.64A2.2,2.2,0,0,1,139.85,400.91Z",
    fill: "#263238",
    style: {
      transformOrigin: "138.391px 406.055px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "140.24 393.06 140.32 397.58 149.3 397.19 149.22 392.71",
    opacity: 0.2,
    style: {
      transformOrigin: "144.77px 395.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127,206.65c-2,10.78.3,63.47,3.35,86.74,4.06,30.9,8.26,102.65,8.26,102.65l12-.72s3-75.56.55-100.37c1.39-31.93,4.83-87.7,4.83-87.7Z",
    fill: "#16A085",
    style: {
      transformOrigin: "141.12px 301.345px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m154 242c0.42-8.09-5.31-15.28-7.62 0-1.46 9.71 1.56 26.73 5.52 38.75 0.61-12.51 1.39-26.44 2.1-38.75z",
    opacity: 0.2,
    style: {
      transformOrigin: "150.014px 256.894px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "215.37 372.19 209.53 377.77 201.62 369.29 207.45 363.72",
    fill: "#b55b52",
    style: {
      transformOrigin: "208.495px 370.745px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M208,377.92l6-8.22a.68.68,0,0,1,.91-.2l7,4.12a1.54,1.54,0,0,1,.4,2.18c-2.13,2.83-3.3,4.08-5.93,7.7-1.62,2.22-3.49,5.28-5.72,8.36s-5.28.87-4.62-.62c3-6.69,1.73-8.55,1.57-11.74A2.48,2.48,0,0,1,208,377.92Z",
    fill: "#263238",
    style: {
      transformOrigin: "214.273px 381.407px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "201.62 369.3 205.7 373.66 211.49 368.04 207.46 363.72",
    opacity: 0.2,
    style: {
      transformOrigin: "206.555px 368.69px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M140.92,206.94s12.92,68,16.28,94.4c2,15.77,46.1,72.51,46.1,72.51l7.53-7.93s-16.14-41.54-35.58-66.18c-.77-28.88,2.51-76.42-8.65-92.27Z",
    fill: "#16A085",
    style: {
      transformOrigin: "175.875px 290.395px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M129.58,154.8c0,5.84-.27,11.57-.7,17.36s-1,11.55-1.93,17.35l-.17,1.09-.23,1.23q-.26,1.21-.57,2.37c-.44,1.53-1,3-1.5,4.42a84.16,84.16,0,0,1-3.72,8.16,118.87,118.87,0,0,1-9.29,14.89,2.48,2.48,0,0,1-4.25-2.5l0-.06c2.35-5.08,4.63-10.29,6.62-15.45,1-2.58,1.89-5.19,2.65-7.75.36-1.28.68-2.55.93-3.79.13-.62.22-1.23.31-1.83l.1-.89.1-1c.51-5.54.81-11.16,1.09-16.79s.41-11.31.57-16.89v-.05a5,5,0,0,1,10,.16Z",
    fill: "#b55b52",
    style: {
      transformOrigin: "118.296px 186.209px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m126.32 147.49c-12.28 3.59-10.7 25.93-10.7 25.93l17.46 4.7s2.9-16.36 2.64-22.23c-0.26-6.1-2.63-10.37-9.4-8.4z",
    fill: "#16A085",
    style: {
      transformOrigin: "125.645px 162.562px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m108.52 217.88-6.15 5.23 8.62 3.52s2.67-4.07 1.43-7.93z",
    fill: "#b55b52",
    style: {
      transformOrigin: "107.559px 222.255px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m103.46 231.09 3.93 0.49a2 2 0 0 0 2.1-1.23l1.5-3.72-8.62-3.52-0.65 5.77a2 2 0 0 0 1.74 2.21z",
    fill: "#b55b52",
    style: {
      transformOrigin: "106.349px 227.353px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M122.35,153.3c-.55,22.4,4.6,38.75,4.66,53.35l39.59.82c-.29-14.62-.17-24.16,6.12-50.36a8.44,8.44,0,0,0-7-10.32c-2.37-.35-5-.68-7.67-.86a126.39,126.39,0,0,0-18-.38c-4.22.3-8.76.92-12,1.41A6.69,6.69,0,0,0,122.35,153.3Z",
    fill: "#16A085",
    style: {
      transformOrigin: "147.631px 176.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M159.25,174l-11.74-.08a.81.81,0,0,1-.84-.9l.65-5.56a1.07,1.07,0,0,1,1.05-.89l11.73.08a.8.8,0,0,1,.84.89l-.65,5.57A1.06,1.06,0,0,1,159.25,174Z",
    fill: "#fff",
    style: {
      transformOrigin: "153.805px 170.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M140.11,145.56s-6.46,4.52.37,15.86a234.05,234.05,0,0,1,17.61-15.49Z",
    fill: "#fff",
    opacity: 0.4,
    style: {
      transformOrigin: "147.718px 153.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m156.73 125.65c-1.25 5.76-2.61 16.34 1.36 20.28a56.65 56.65 0 0 0-17 10.48c-4.39-8.06-1-10.86-1-10.86 6.48-1.4 6.42-6.19 5.39-10.71z",
    fill: "#b55b52",
    style: {
      transformOrigin: "148.466px 141.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M155.51,126.65a24.17,24.17,0,0,1-2.61,9.88c-1.09,2.11-4,3-6.93,3.17a15.76,15.76,0,0,0-.47-4.86Z",
    opacity: 0.2,
    style: {
      transformOrigin: "150.505px 133.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M166.1,118.6c-3,9.22-4,13.18-10,16.78-8.95,5.41-19.62-.24-19.48-10.15.14-8.92,5-22.49,15.07-23.88A13.2,13.2,0,0,1,166.1,118.6Z",
    fill: "#b55b52",
    style: {
      transformOrigin: "151.7px 119.346px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m141.65 106.49c5 1.41 17.18 2.46 19.62 1-2.29 3.52-0.11 13.14 3.43 15.47 4.77-3.83 5.83-13.09 1.42-17.68s-18.35-10.08-24.47 1.21z",
    fill: "#263238",
    style: {
      transformOrigin: "155.282px 111.393px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m167.5 124.24a7 7 0 0 1-3.68 4c-2.26 1-3.76-0.92-3.44-3.25 0.29-2.09 1.82-5.14 4.24-5.18a3.18 3.18 0 0 1 2.88 4.43z",
    fill: "#b55b52",
    style: {
      transformOrigin: "164.047px 124.161px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M167.24,205.16l1.72,3.59c.13.27-.2.55-.66.54l-41.53-.87c-.35,0-.64-.19-.66-.42l-.29-3.55c0-.24.3-.44.69-.44l40.1.84A.71.71,0,0,1,167.24,205.16Z",
    fill: "#263238",
    style: {
      transformOrigin: "147.404px 206.65px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M161.77,209.53l1.07,0c.21,0,.38-.11.37-.24l-.41-4.62c0-.13-.2-.25-.41-.25l-1.08,0c-.21,0-.37.1-.36.24l.4,4.61C161.37,209.42,161.55,209.53,161.77,209.53Z",
    fill: "#16A085",
    style: {
      transformOrigin: "162.08px 206.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M129.78,208.87l1.08,0c.21,0,.38-.1.37-.24l-.41-4.62c0-.13-.2-.24-.41-.25l-1.08,0c-.21,0-.38.1-.36.24l.4,4.61C129.39,208.75,129.57,208.86,129.78,208.87Z",
    fill: "#16A085",
    style: {
      transformOrigin: "130.099px 206.315px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M145.77,209.2l1.08,0c.21,0,.38-.1.37-.24l-.41-4.61c0-.14-.2-.25-.41-.25l-1.08,0c-.21,0-.37.11-.36.24l.4,4.62C145.38,209.08,145.56,209.2,145.77,209.2Z",
    fill: "#16A085",
    style: {
      transformOrigin: "146.09px 206.65px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.71,117.83c-.2.76-.76,1.28-1.26,1.15s-.74-.85-.55-1.61.76-1.28,1.26-1.15S151.9,117.07,151.71,117.83Z",
    fill: "#263238",
    style: {
      transformOrigin: "150.805px 117.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M143.09,115.63c-.19.77-.75,1.28-1.25,1.15s-.75-.84-.55-1.61.75-1.27,1.25-1.15S143.29,114.87,143.09,115.63Z",
    fill: "#263238",
    style: {
      transformOrigin: "142.19px 115.401px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m142.75 114.12-1.7-1s0.58 1.68 1.7 1z",
    fill: "#263238",
    style: {
      transformOrigin: "141.9px 113.701px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m145 117.52a21.08 21.08 0 0 1-3.95 4.18 3.38 3.38 0 0 0 2.58 1.2z",
    fill: "#a02724",
    style: {
      transformOrigin: "143.025px 120.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M145.48,125.89a.25.25,0,0,1-.08-.25.23.23,0,0,1,.29-.15,6.25,6.25,0,0,0,5.56-.92.23.23,0,0,1,.3.35,6.57,6.57,0,0,1-6,1Z",
    fill: "#263238",
    style: {
      transformOrigin: "148.511px 125.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M156.41,114.32a.7.7,0,0,1-.15-.19,3.65,3.65,0,0,0-2.48-2.23.46.46,0,0,1,.16-.91,4.61,4.61,0,0,1,3.18,2.78.47.47,0,0,1-.71.55Z",
    fill: "#263238",
    style: {
      transformOrigin: "155.274px 112.694px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M141.39,110.77l-.06-.06a.46.46,0,0,1,0-.65,4.61,4.61,0,0,1,4-1.17.46.46,0,0,1,.33.57.46.46,0,0,1-.56.33,3.65,3.65,0,0,0-3.2.95A.46.46,0,0,1,141.39,110.77Z",
    fill: "#263238",
    style: {
      transformOrigin: "143.436px 109.822px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M172.71,153.86c2.91,3.85,5.63,7.73,8.27,11.76,1.31,2,2.61,4,3.84,6.16a62.15,62.15,0,0,1,3.56,6.78,20.32,20.32,0,0,1,.82,2.23,10.2,10.2,0,0,1,.34,1.79,5.38,5.38,0,0,1,0,.73l0,.45a5,5,0,0,1-.09.59l-.07.31,0,.14v0l0,.11-.08.22c-.47,1.2-.84,2.41-1.4,3.57a44.8,44.8,0,0,1-3.64,6.83,34.09,34.09,0,0,1-5.06,6,24.61,24.61,0,0,1-3.13,2.49c-.57.37-1.15.73-1.75,1.06l-.95.46c-.36.16-.62.27-1.14.46l-1.9-4.56a4.43,4.43,0,0,1,.43-.37l.55-.48c.37-.33.73-.69,1.08-1.06a27.18,27.18,0,0,0,2-2.41,35.12,35.12,0,0,0,3.18-5.45c.42-1,.88-1.94,1.23-3s.74-2,1.06-3,.57-2.1.88-3.14l0-.19,0-.1v0l0,.09,0,.2c0,.12-.05.3-.06.37a1.79,1.79,0,0,0,0,.23v.29c0,.23,0,.16,0,.06s-.28-.64-.49-1.06c-.91-1.71-2.13-3.68-3.38-5.56s-2.55-3.81-3.88-5.7c-2.65-3.79-5.38-7.62-8.06-11.38Z",
    fill: "#b55b52",
    style: {
      transformOrigin: "177.211px 179.93px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m174.88 204.82-7.71 5.45-3.46-7.88s4.68-2.51 8.37-0.83z",
    fill: "#b55b52",
    style: {
      transformOrigin: "169.295px 205.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m161.8 210.92-1.93-2.69a2.44 2.44 0 0 1 0.53-3.36l3.31-2.48 3.46 7.88-2.12 1.31a2.43 2.43 0 0 1-3.25-0.66z",
    fill: "#b55b52",
    style: {
      transformOrigin: "163.297px 207.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m157.28 151.48c-2.62 10.41 13.54 28.23 13.54 28.23l13.59-14.11s-6.21-13.26-14.32-17.42c-5.66-2.9-11.65-1.29-12.81 3.3z",
    fill: "#16A085",
    style: {
      transformOrigin: "170.701px 163.218px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m151.37 116.32-1.7-1s0.57 1.68 1.7 1z",
    fill: "#263238",
    style: {
      transformOrigin: "150.52px 115.901px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M134,179.29a.37.37,0,0,1-.34-.23.36.36,0,0,1,.21-.46l1.56-.6a7.65,7.65,0,0,0,5-7.14l.11-14.62A4.86,4.86,0,0,0,131.3,154l-6.76,13a7.68,7.68,0,0,0,1,8.64l1.1,1.25a.36.36,0,1,1-.54.47L125,176a8.35,8.35,0,0,1-1.13-9.44l6.76-13a5.57,5.57,0,0,1,10.51,2.62l-.11,14.62a8.38,8.38,0,0,1-5.42,7.8l-1.56.59Z",
    fill: "#263238",
    style: {
      transformOrigin: "132.021px 164.926px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M140.79,159.5a.37.37,0,0,1-.36-.35A5.76,5.76,0,0,0,130,156.54a.36.36,0,1,1-.63-.35,6.48,6.48,0,0,1,11.81,2.94.37.37,0,0,1-.35.37Z",
    fill: "#263238",
    style: {
      transformOrigin: "135.252px 156.421px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M136.89,151.51a.37.37,0,0,1-.3-.16,3.14,3.14,0,0,1,0-2.58,5.65,5.65,0,0,1,3.37-3.55.34.34,0,0,1,.45.22.36.36,0,0,1-.22.45A5.06,5.06,0,0,0,137.3,149a2.61,2.61,0,0,0-.11,2,.36.36,0,0,1-.11.5A.41.41,0,0,1,136.89,151.51Z",
    fill: "#263238",
    style: {
      transformOrigin: "138.37px 148.357px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m133.18 178.74c-0.17 0.65 0 1.27 0.48 1.38s0.92-0.34 1.08-1-0.06-1.28-0.49-1.38-0.91 0.34-1.07 1z",
    fill: "#263238",
    style: {
      transformOrigin: "133.954px 178.931px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m161.56 161.47c0.32 1.51 1.4 2.55 2.39 2.34s1.53-1.62 1.2-3.12-1.4-2.56-2.39-2.34-1.53 1.65-1.2 3.12z",
    fill: "#263238",
    style: {
      transformOrigin: "163.355px 161.079px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M164.69,161a.35.35,0,0,1-.36-.34c-.21-5.53-2.31-12.4-6.4-14.43a.36.36,0,0,1-.16-.48.35.35,0,0,1,.48-.16c4.38,2.17,6.57,9.12,6.79,15a.34.34,0,0,1-.34.37Z",
    fill: "#263238",
    style: {
      transformOrigin: "161.387px 153.275px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m160.49 161.6c0.21 1.29 1.14 2.21 2.08 2.06s1.54-1.32 1.33-2.62-1.15-2.21-2.09-2.06-1.53 1.32-1.32 2.62z",
    fill: "#fff",
    style: {
      transformOrigin: "162.195px 161.32px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m160.41 161.71c0.3 1.6 1.14 2.78 1.87 2.64s1.06-1.54 0.76-3.14-1.14-2.78-1.87-2.64-1.07 1.54-0.76 3.14z",
    fill: "#263238",
    style: {
      transformOrigin: "161.723px 161.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M125.62,176.85c-.16.66.06,1.28.49,1.38s.91-.33,1.08-1-.06-1.27-.49-1.38S125.79,176.2,125.62,176.85Z",
    fill: "#263238",
    style: {
      transformOrigin: "126.407px 177.039px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "224.572px 242.269px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M235.16,95.42c-6.33,1.13-7.13.55-7.21-4s-2.38-12.14.82-14.52a1.73,1.73,0,0,1,2.87.84,2.08,2.08,0,0,1,2.61-1.21c.13-.94.28-3.35,2-4s3.3.91,3.3.91-.13-3.71,2.37-3.35A3.76,3.76,0,0,1,245,73s1.44-2.1,3.39-1.27S249.93,75,249.93,75s2.07-1,3.61.13.42,2.94.42,2.94,1.4-3.6,4.07-1.61c2.4,1.8.22,4.62.22,4.62s2.64-.43,3.28.9c2.16,4.53-6.07,9.59-6.34,17.24C242.55,104,235.16,95.42,235.16,95.42Z",
    fill: "#263238",
    style: {
      transformOrigin: "244.483px 85.367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M189.54,217l-4.22-.78-5.58,5.33a3,3,0,0,0-.93,2.25l.08,4.36a3,3,0,0,0,2.75,2.95l1.94.17a3,3,0,0,0,3.18-2.21l1-3.56S193.27,219,189.54,217Z",
    fill: "#ffb573",
    style: {
      transformOrigin: "184.822px 223.757px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M232.16,137.26c-2.83,7.33-5.65,14.69-8.37,22.07s-5.42,14.79-7.95,22.08l-.45,1.35-.31.88c-.12.33-.24.67-.35.93-.47,1.19-.94,2.17-1.41,3.16-.94,2-1.89,3.79-2.85,5.6-1.93,3.6-3.92,7.07-5.93,10.53-4,6.93-8,13.7-12.14,20.57l-12.73-7.92c4.2-6.53,8.25-13.27,12.13-20,1.91-3.38,3.79-6.77,5.54-10.13.87-1.68,1.71-3.36,2.45-5,.35-.79.7-1.6.93-2.26.08-.19.11-.32.16-.45l.16-.52.46-1.46c2.41-7.68,4.94-15.1,7.38-22.63l7.32-22.51Z",
    fill: "#16A085",
    style: {
      transformOrigin: "205.915px 177.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M232.16,137.26c-2.83,7.33-5.65,14.69-8.37,22.07s-5.42,14.79-7.95,22.08l-.45,1.35-.31.88c-.12.33-.24.67-.35.93-.47,1.19-.94,2.17-1.41,3.16-.94,2-1.89,3.79-2.85,5.6-1.93,3.6-3.92,7.07-5.93,10.53-4,6.93-8,13.7-12.14,20.57l-12.73-7.92c4.2-6.53,8.25-13.27,12.13-20,1.91-3.38,3.79-6.77,5.54-10.13.87-1.68,1.71-3.36,2.45-5,.35-.79.7-1.6.93-2.26.08-.19.11-.32.16-.45l.16-.52.46-1.46c2.41-7.68,4.94-15.1,7.38-22.63l7.32-22.51Z",
    fill: "#fff",
    opacity: 0.6,
    style: {
      transformOrigin: "205.915px 177.99px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "194.02 404.91 185.05 405.35 189.29 381.99 197.82 383.95",
    fill: "#ffb573",
    style: {
      transformOrigin: "191.435px 393.67px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "258.37 405.25 249.4 405.25 249.43 384.48 258.39 384.48",
    fill: "#ffb573",
    style: {
      transformOrigin: "253.895px 394.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M248.55,404.21h10.93a.74.74,0,0,1,.74.61l1.44,8a1.38,1.38,0,0,1-1.37,1.6c-3.52-.06-6.08-.27-10.51-.27-2.72,0-11,.28-14.72.28s-4.1-3.72-2.55-4.06c7-1.51,12.27-3.59,14.56-5.58A2.24,2.24,0,0,1,248.55,404.21Z",
    fill: "#263238",
    style: {
      transformOrigin: "246.665px 409.32px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "189.29 382 187.33 392.8 195.86 394.76 197.82 383.96",
    opacity: 0.2,
    style: {
      transformOrigin: "192.575px 388.38px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 249.42,
    y: 384.48,
    width: 8.97,
    height: 10.7,
    opacity: 0.2,
    style: {
      transformOrigin: "253.905px 389.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M265.61,137c-7,31.49-5.14,62.57-5.89,69.3l-47.87-3.16c-5-38,.58-62.24,3.75-72.18a9,9,0,0,1,7.44-6.23,137.77,137.77,0,0,1,21.44-.67,80,80,0,0,1,14.36,2.18A9,9,0,0,1,265.61,137Z",
    fill: "#16A085",
    style: {
      transformOrigin: "237.842px 165.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M251.18,102.72c-1.58,5.93-3.45,16.43-.44,21.74.47.83-.43,1.54-.47,2.5-.11,2.94-4.09,3.82-11.21,3.86s-10.17-2.93-8.23-5.73a2,2,0,0,1,1.26-.82c6.67-1.49,6.8-6.72,5.89-11.71Z",
    fill: "#ffb573",
    style: {
      transformOrigin: "240.719px 116.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m238.55 129.19a19.11 19.11 0 0 1 3.45 8.81c7.11-3.34 10.5-11.45 10.5-11.45l-2.14-2.29s-7.9 1.49-11.81 4.93z",
    opacity: 0.4,
    style: {
      transformOrigin: "245.525px 131.13px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m237.85 129.22a27.88 27.88 0 0 0-6.52 7.64c-4.97-3.08-3.33-11.86-3.33-11.86l4.05-0.8s1.81 1.67 5.8 5.02z",
    opacity: 0.4,
    style: {
      transformOrigin: "232.795px 130.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M238.17,129l-1.53.15-2.59,1.71a4.69,4.69,0,0,0,.52,3,18.35,18.35,0,0,0,4.57.31,4.83,4.83,0,0,0,2.31-2.38l-1.9-2.43Z",
    fill: "#263238",
    style: {
      transformOrigin: "237.72px 131.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m238.17 129a25.69 25.69 0 0 1 4.35 8.06c7.11-3.34 11.25-11.32 11.25-11.32l-3.43-3s-8.26 2.84-12.17 6.26z",
    fill: "#16A085",
    style: {
      transformOrigin: "245.97px 129.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m238.17 129a26.31 26.31 0 0 0-7.08 6.56c-5-3.07-3.09-11.34-3.09-11.34l4.05-0.8s2.14 2.25 6.12 5.58z",
    fill: "#16A085",
    style: {
      transformOrigin: "232.906px 129.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m245.8 106.73-7.8 5.82a21 21 0 0 1 0.39 3.65c2.81-0.21 6.85-3 7.34-5.92a10 10 0 0 0 0.07-3.55z",
    opacity: 0.2,
    style: {
      transformOrigin: "241.963px 111.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m252.61 92.92c-1.13 8.83-1.34 14-6.12 18.31-7.19 6.39-17.86 1.61-19.39-7.38-1.38-8.09 0.7-21.17 9.61-24.12a12.14 12.14 0 0 1 15.9 13.19z",
    fill: "#ffb573",
    style: {
      transformOrigin: "239.719px 96.6276px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m250.45 100.9c-2-1.93-0.75-11.17 0.26-13.82-5 0.48-21.16 0.46-20.55-4s6.49-8.25 16.1-5.12c8 2.61 10 6.6 10 9.86 0.12 6.7-5.81 13.08-5.81 13.08z",
    fill: "#263238",
    style: {
      transformOrigin: "243.202px 88.8559px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m255.71 101a7.84 7.84 0 0 1-4.52 3.82c-2.55 0.79-3.81-1.56-3.09-4.08 0.64-2.26 2.75-5.41 5.3-5.09s3.48 3.1 2.31 5.35z",
    fill: "#ffb573",
    style: {
      transformOrigin: "252.055px 100.301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m184.41 390.06 14.83 3.27s14.42-56.51 18.7-84.13c1.31-8.4 4.35-20.39 7.12-33 3.49-15.9 7.88-33.1 11.48-46.57 3.8-14.19 6.62-24.39 6.62-24.39l-31.31-2.07s-14.57 73.91-17.51 101.12c-3.07 28.28-9.93 85.77-9.93 85.77z",
    fill: "#263238",
    style: {
      transformOrigin: "213.785px 298.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m225.06 276.18c3.49-15.9 7.88-33.1 11.48-46.57l-3.29-7c-7.77 9.28-9.76 37.99-8.19 53.57z",
    opacity: 0.2,
    style: {
      transformOrigin: "230.551px 249.395px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M226.77,204.13s6.48,75.53,9,101.68c2.8,28.64,10.31,87.31,10.31,87.31h15.06s.68-62.48-2-90.14c-.38-54.38.57-96.67.57-96.67Z",
    fill: "#263238",
    style: {
      transformOrigin: "243.994px 298.625px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "244.16 393.47 263.5 393.47 263.5 387.69 243.41 386.58",
    fill: "#16A085",
    style: {
      transformOrigin: "253.455px 390.025px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "182.47 390 200.14 393.9 201.4 388.19 182.9 383.53",
    fill: "#16A085",
    style: {
      transformOrigin: "191.935px 388.715px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M239.7,94.5c0,.72-.47,1.28-.94,1.25s-.82-.64-.77-1.36.47-1.28.94-1.25S239.75,93.78,239.7,94.5Z",
    fill: "#263238",
    style: {
      transformOrigin: "238.845px 94.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M231.54,94c0,.72-.47,1.28-.94,1.25s-.82-.64-.77-1.36.47-1.28.94-1.25S231.59,93.24,231.54,94Z",
    fill: "#263238",
    style: {
      transformOrigin: "230.685px 93.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M233.41,94.5a26.16,26.16,0,0,1-3.85,5.94c1.19,1.28,3.4.88,3.4.88Z",
    fill: "#ed893e",
    style: {
      transformOrigin: "231.485px 97.9396px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M235.88,103.45a6,6,0,0,0,4.23-2.1.21.21,0,0,0,0-.29.22.22,0,0,0-.3,0A5.75,5.75,0,0,1,235,103a.21.21,0,0,0-.23.19.22.22,0,0,0,.2.23A7.52,7.52,0,0,0,235.88,103.45Z",
    fill: "#263238",
    style: {
      transformOrigin: "237.469px 102.227px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M241.69,92a.48.48,0,0,0,.2-.07.43.43,0,0,0,.13-.59,4.25,4.25,0,0,0-3.34-2,.43.43,0,0,0,0,.85h0a3.38,3.38,0,0,1,2.63,1.6A.41.41,0,0,0,241.69,92Z",
    fill: "#263238",
    style: {
      transformOrigin: "240.201px 90.6703px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M227.51,90.93a.43.43,0,0,0,.34-.21A3.37,3.37,0,0,1,230.37,89a.44.44,0,0,0,.4-.45.43.43,0,0,0-.45-.4,4.22,4.22,0,0,0-3.21,2.19.42.42,0,0,0,.16.57A.36.36,0,0,0,227.51,90.93Z",
    fill: "#263238",
    style: {
      transformOrigin: "228.914px 89.5457px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M245.52,405.77a10.77,10.77,0,0,0,2.36-.32.21.21,0,0,0,.16-.17.19.19,0,0,0-.08-.21c-.32-.21-3.14-2-4.16-1.48a.71.71,0,0,0-.38.6,1.24,1.24,0,0,0,.39,1.13A2.63,2.63,0,0,0,245.52,405.77Zm1.75-.62c-1.53.31-2.7.25-3.17-.16a.82.82,0,0,1-.26-.77c0-.16.08-.22.14-.25C244.51,403.71,246.13,404.47,247.27,405.15Z",
    fill: "#16A085",
    style: {
      transformOrigin: "245.724px 404.638px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M247.83,405.46a.15.15,0,0,0,.11,0,.21.21,0,0,0,.11-.19c0-.11-.11-2.7-1.12-3.55a1.13,1.13,0,0,0-.9-.27h0a.71.71,0,0,0-.69.55c-.23,1,1.48,3,2.39,3.47A.17.17,0,0,0,247.83,405.46Zm-1.66-3.64a.72.72,0,0,1,.48.19c.64.54.87,2.05.94,2.81-.89-.7-2-2.19-1.84-2.78,0-.05,0-.18.32-.21h.1Z",
    fill: "#16A085",
    style: {
      transformOrigin: "246.685px 403.456px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M183.71,401.4l10.52,3a.75.75,0,0,1,.54.79l-.78,8.07a1.39,1.39,0,0,1-1.76,1.16c-3.37-1-5.77-1.91-10-3.12-2.62-.74-11.15-3.8-14.26-5.92s-1.28-5.39.19-4.79c6.61,2.68,11.26,2.25,14,1A2.27,2.27,0,0,1,183.71,401.4Z",
    fill: "#263238",
    style: {
      transformOrigin: "180.522px 407.496px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M180.36,402.08a11.39,11.39,0,0,0,2.36.33.22.22,0,0,0,.21-.12.2.2,0,0,0,0-.23c-.25-.28-2.48-2.76-3.59-2.55a.74.74,0,0,0-.54.48,1.25,1.25,0,0,0,.07,1.18A2.68,2.68,0,0,0,180.36,402.08Zm1.86-.12c-1.56-.12-2.67-.5-3-1a.85.85,0,0,1,0-.81c.06-.16.14-.19.21-.2C180,399.82,181.3,401,182.22,402Z",
    fill: "#16A085",
    style: {
      transformOrigin: "180.825px 400.954px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M182.67,402.4a.24.24,0,0,0,.12,0,.22.22,0,0,0,.16-.16c0-.1.62-2.62-.11-3.72a1.15,1.15,0,0,0-.79-.5h0a.72.72,0,0,0-.82.34c-.5.9.62,3.26,1.35,4A.2.2,0,0,0,182.67,402.4Zm-.61-3.95a.7.7,0,0,1,.41.31c.48.7.28,2.22.15,3-.67-.91-1.31-2.64-1-3.17,0-.05.09-.16.37-.12h0Z",
    fill: "#16A085",
    style: {
      transformOrigin: "182.151px 400.201px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M251.33,123.68a.71.71,0,0,0-.82.76c.35,5.36-8,15-10,43.87-1.19,17.56-2.28,72.31-1.48,100.79a2.46,2.46,0,0,0,3.13,2.29c14.76-4.12,21.73,5.87,24.57-5.91-.15-14.11-4.42-64.77-3.32-76.78s5.67-44.64,6.81-53.34C271.23,127.8,255.46,124.43,251.33,123.68Z",
    fill: "#16A085",
    style: {
      transformOrigin: "254.511px 197.577px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M251.33,123.68a.71.71,0,0,0-.82.76c.35,5.36-8,15-10,43.87-1.19,17.56-2.28,72.31-1.48,100.79a2.46,2.46,0,0,0,3.13,2.29c14.76-4.12,21.73,5.87,24.57-5.91-.15-14.11-4.42-64.77-3.32-76.78s5.67-44.64,6.81-53.34C271.23,127.8,255.46,124.43,251.33,123.68Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      transformOrigin: "254.511px 197.577px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M261.06,148.15c-.65,4.46-.9,22.48,3.39,31.15.72-6,1.66-13.13,2.57-20Z",
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "263.857px 163.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m267.19 226.08-4.26 0.5-3.77 6.73a3 3 0 0 0-0.24 2.42l1.36 4.14a3 3 0 0 0 3.5 2l1.9-0.4a3 3 0 0 0 2.4-3.06l-0.12-3.68s3.38-7.81-0.77-8.65z",
    fill: "#ffb573",
    style: {
      transformOrigin: "264.013px 234.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M269.53,132c1.36,4,2.62,7.95,3.87,11.95s2.5,8,3.68,12,2.32,8.09,3.37,12.26c.52,2.09,1,4.2,1.46,6.41.21,1.11.42,2.24.59,3.44.08.62.17,1.19.22,1.88l.09,1,.05,1.13a10.86,10.86,0,0,1,0,1.14c0,.4,0,.78-.05,1.09l-.09,1-.11.9c-.14,1.21-.32,2.31-.5,3.41-.36,2.18-.78,4.28-1.21,6.36-.86,4.16-1.82,8.23-2.79,12.28s-2,8.09-3,12.12l-3,12.09-14.48-3.93c2.24-7.81,4.28-15.76,6.17-23.66.92-4,1.78-7.92,2.55-11.83.38-2,.74-3.9,1-5.78.15-.94.27-1.87.35-2.71a13.07,13.07,0,0,0,.08-2l0-.42-.07-.54c0-.34-.12-.79-.18-1.18-.14-.84-.32-1.73-.52-2.64-.41-1.82-.9-3.7-1.43-5.59-1-3.79-2.27-7.63-3.56-11.45-2.55-7.64-5.42-15.33-8.38-22.81Z",
    fill: "#16A085",
    style: {
      transformOrigin: "268.257px 182.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M269.53,132c1.36,4,2.62,7.95,3.87,11.95s2.5,8,3.68,12,2.32,8.09,3.37,12.26c.52,2.09,1,4.2,1.46,6.41.21,1.11.42,2.24.59,3.44.08.62.17,1.19.22,1.88l.09,1,.05,1.13a10.86,10.86,0,0,1,0,1.14c0,.4,0,.78-.05,1.09l-.09,1-.11.9c-.14,1.21-.32,2.31-.5,3.41-.36,2.18-.78,4.28-1.21,6.36-.86,4.16-1.82,8.23-2.79,12.28s-2,8.09-3,12.12l-3,12.09-14.48-3.93c2.24-7.81,4.28-15.76,6.17-23.66.92-4,1.78-7.92,2.55-11.83.38-2,.74-3.9,1-5.78.15-.94.27-1.87.35-2.71a13.07,13.07,0,0,0,.08-2l0-.42-.07-.54c0-.34-.12-.79-.18-1.18-.14-.84-.32-1.73-.52-2.64-.41-1.82-.9-3.7-1.43-5.59-1-3.79-2.27-7.63-3.56-11.45-2.55-7.64-5.42-15.33-8.38-22.81Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      transformOrigin: "268.257px 182.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m231.88 122.93a1.16 1.16 0 0 1 0.91 1.89c-2.38 2.76-3.88 6.55-6.7 18.71-3.4 14.67-10.64 88.48-12 124.65a2.08 2.08 0 0 1-2.45 2c-7.06-1.3-11.9 2.12-12.67-2.41-0.85-5 2.32-52.76 8.25-75.22-0.93-19.92 2.43-59.88 9.14-65.19 3.64-2.95 11.38-4.36 15.52-4.43z",
    fill: "#16A085",
    style: {
      transformOrigin: "215.941px 196.572px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m231.88 122.93a1.16 1.16 0 0 1 0.91 1.89c-2.38 2.76-3.88 6.55-6.7 18.71-3.4 14.67-10.64 88.48-12 124.65a2.08 2.08 0 0 1-2.45 2c-7.06-1.3-11.9 2.12-12.67-2.41-0.85-5 2.32-52.76 8.25-75.22-0.93-19.92 2.43-59.88 9.14-65.19 3.64-2.95 11.38-4.36 15.52-4.43z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      transformOrigin: "215.941px 196.572px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M235.77,132.84s-8.64,24.27-11.68,44.61c-.24,5.53,2.39,16.24,4.52,20.91,4.45-9.69,7.23-15.4,7.67-20.91.71-8.29,1.88-44.45,1.88-44.45Z",
    fill: "#263238",
    style: {
      transformOrigin: "231.117px 165.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M253.85,161.71a.4.4,0,0,1-.18-.75l1.64-.86a8.47,8.47,0,0,0,4.54-8.5l-1.78-16.12a5.38,5.38,0,0,0-10.38-1.32l-5.76,15.15a8.48,8.48,0,0,0,2.25,9.37l1.38,1.25a.4.4,0,0,1,0,.56.4.4,0,0,1-.56,0l-1.38-1.24A9.28,9.28,0,0,1,241.19,149L247,133.88a6.18,6.18,0,0,1,11.91,1.52l1.78,16.11a9.28,9.28,0,0,1-5,9.3l-1.64.85A.32.32,0,0,1,253.85,161.71Z",
    fill: "#263238",
    style: {
      transformOrigin: "250.654px 145.813px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M258.81,139a.39.39,0,0,1-.39-.34,5.92,5.92,0,0,0-5.41-4.86c-2.22-.28-5.24.42-6.45,3.34a.4.4,0,1,1-.74-.3,7.18,7.18,0,0,1,13.38,1.71.39.39,0,0,1-.33.44Z",
    fill: "#263238",
    style: {
      transformOrigin: "252.492px 135.979px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M253.43,130.73h0a.39.39,0,0,1-.37-.42c.12-1.95-.16-5.5-2-6.42a.4.4,0,0,1,.37-.71c2.66,1.37,2.42,6.59,2.38,7.18A.39.39,0,0,1,253.43,130.73Z",
    fill: "#263238",
    style: {
      transformOrigin: "252.339px 126.933px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M246.18,160.33c-.1.75-.57,1.3-1.06,1.23s-.81-.71-.71-1.45.56-1.3,1.05-1.23S246.27,159.59,246.18,160.33Z",
    fill: "#263238",
    style: {
      transformOrigin: "245.293px 160.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m222.93 144.12c-0.63 1.59-2 2.55-3 2.14s-1.39-2-0.76-3.63 2-2.55 3-2.14 1.38 2.04 0.76 3.63z",
    fill: "#263238",
    style: {
      transformOrigin: "221.048px 143.374px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M219.64,143.09h-.08a.4.4,0,0,1-.31-.47c1.32-6.57,6.78-17,11.59-20a.4.4,0,1,1,.42.67c-4.65,2.93-9.94,13-11.23,19.47A.4.4,0,0,1,219.64,143.09Z",
    fill: "#263238",
    style: {
      transformOrigin: "225.372px 132.806px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m224.07 144.45c-0.46 1.37-1.64 2.22-2.64 1.89s-1.45-1.72-1-3.1 1.64-2.22 2.64-1.89 1.46 1.72 1 3.1z",
    fill: "#fff",
    style: {
      transformOrigin: "222.252px 143.845px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m224.14 144.59c-0.61 1.69-1.74 2.84-2.51 2.56s-0.9-1.88-0.28-3.58 1.74-2.84 2.51-2.56 0.9 1.88 0.28 3.58z",
    fill: "#263238",
    style: {
      transformOrigin: "222.745px 144.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M254.74,161.43c-.09.74-.57,1.29-1.06,1.23s-.81-.72-.71-1.46.57-1.29,1.06-1.23S254.84,160.68,254.74,161.43Z",
    fill: "#263238",
    style: {
      transformOrigin: "253.855px 161.315px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "342.217px 253.613px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m311.44 118.1c3.34 9.13-5.54 13.72-11.36 27.17s8.22 29.49 29.77 29.84 22.23-20.29 18.89-35.1 3.64-17.22 2.16-28.53c-1.9-14.86-23.31-26.12-31.81-12.48-7.56-0.71-10.57 11.12-7.65 19.1z",
    fill: "#263238",
    style: {
      transformOrigin: "324.934px 133.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M375.27,241l0-1.16a3.87,3.87,0,0,0-.41-1.6l-3.62-7.14L367,230.3c-3,3.23,0,9.67,0,9.67V241a3.88,3.88,0,0,0,2.82,3.73l.57.17A3.89,3.89,0,0,0,375.27,241Z",
    fill: "#ffc3bd",
    style: {
      transformOrigin: "370.47px 237.664px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M357.3,149.15l1.56,10.94L360.5,171c.54,3.65,1.11,7.28,1.69,10.92l1.73,10.84.21,1.07c.07.35.19.8.28,1.19l.3,1.23.35,1.27c.45,1.68,1,3.42,1.48,5.14,1,3.45,2.15,6.94,3.28,10.41,2.3,6.93,4.7,13.89,7.26,20.73l-14.14,5-7.08-21.14c-1.17-3.53-2.36-7.06-3.49-10.66-.56-1.81-1.12-3.6-1.65-5.47l-.41-1.39-.39-1.45c-.13-.5-.27-.94-.39-1.49l-.37-1.64-2.09-11q-1-5.44-2.09-10.88l-2.14-10.88L340.61,152Z",
    fill: "#16A085",
    style: {
      transformOrigin: "358.845px 193.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M357.3,149.15l1.56,10.94L360.5,171c.54,3.65,1.11,7.28,1.69,10.92l1.73,10.84.21,1.07c.07.35.19.8.28,1.19l.3,1.23.35,1.27c.45,1.68,1,3.42,1.48,5.14,1,3.45,2.15,6.94,3.28,10.41,2.3,6.93,4.7,13.89,7.26,20.73l-14.14,5-7.08-21.14c-1.17-3.53-2.36-7.06-3.49-10.66-.56-1.81-1.12-3.6-1.65-5.47l-.41-1.39-.39-1.45c-.13-.5-.27-.94-.39-1.49l-.37-1.64-2.09-11q-1-5.44-2.09-10.88l-2.14-10.88L340.61,152Z",
    fill: "#fff",
    opacity: 0.6,
    style: {
      transformOrigin: "358.845px 193.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M355.05,148.31c.47,5.33.05,18.59-5.3,51.46h-37c.59-14.28.63-23.38-5.5-50.63a4.6,4.6,0,0,1,3.75-5.56,101.37,101.37,0,0,1,10.91-1.19,117.9,117.9,0,0,1,16.82,0c4.6.42,9.59,1.25,12.61,1.8A4.58,4.58,0,0,1,355.05,148.31Z",
    fill: "#263238",
    style: {
      transformOrigin: "331.165px 170.93px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m323.54 123.45c1.06 5.41 2.12 15.33-1.67 18.94 0 0 4.74 5.76 12 5.76s4.83-5.76 4.83-5.76c-6-1.44-5.88-5.92-4.83-10.12z",
    fill: "#ffc3bd",
    style: {
      transformOrigin: "330.48px 135.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m327.75 127.05 6.11 5.21a17.68 17.68 0 0 0-0.52 3c-2.31-0.33-5.93-2.3-6.43-4.81-0.23-1.19 0.64-2.84 0.84-3.4z",
    opacity: 0.2,
    style: {
      transformOrigin: "330.366px 131.155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m317.17 112.83c1.41 8.94 1.82 12.75 6.8 16.93 7.5 6.29 18.17 2.6 19.46-6.58 1.16-8.26-1.35-21.5-10.49-24.23a12.35 12.35 0 0 0-15.77 13.88z",
    fill: "#ffc3bd",
    style: {
      transformOrigin: "330.345px 115.653px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m318.66 119.27c5.12-5.07 6.88-12.12 6.4-15 4.93 1.37 8.55-0.57 8.33-1.41 3.48 3.4 9.79 6.09 9.08 2.43s-5.38-10.41-15.12-8-13.49 12.41-13.35 16.47 4.66 5.51 4.66 5.51z",
    fill: "#263238",
    style: {
      transformOrigin: "328.261px 108.026px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M330,113.84c.07.74.51,1.29,1,1.25s.81-.68.74-1.41-.52-1.29-1-1.25S330,113.11,330,113.84Z",
    fill: "#263238",
    style: {
      transformOrigin: "330.875px 113.76px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M338.31,113.05c.07.73.52,1.29,1,1.24s.81-.67.74-1.4-.52-1.29-1-1.25S338.24,112.32,338.31,113.05Z",
    fill: "#263238",
    style: {
      transformOrigin: "339.18px 112.966px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m338.85 111.7 1.71-0.67s-0.78 1.46-1.71 0.67z",
    fill: "#263238",
    style: {
      transformOrigin: "339.705px 111.482px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M335.89,114.61a19.62,19.62,0,0,0,3.05,4.43,3.18,3.18,0,0,1-2.56.74Z",
    fill: "#ed847e",
    style: {
      transformOrigin: "337.415px 117.213px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M332.66,123a8,8,0,0,0,1.09,0,.22.22,0,0,0,.19-.24.2.2,0,0,0-.23-.19,5.85,5.85,0,0,1-4.95-1.82.22.22,0,0,0-.34.27A6.08,6.08,0,0,0,332.66,123Z",
    fill: "#263238",
    style: {
      transformOrigin: "331.167px 121.856px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m315.19 120.1a6.65 6.65 0 0 0 3.56 3.59c2.14 0.88 3.49-1 3.12-3.13-0.33-2-1.85-4.77-4.11-4.73a3 3 0 0 0-2.57 4.27z",
    fill: "#ffc3bd",
    style: {
      transformOrigin: "318.419px 119.871px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M327.15,110a.44.44,0,0,0,.49-.14c1.26-1.55,3.83-1.4,3.85-1.4a.44.44,0,0,0,.46-.4.42.42,0,0,0-.4-.46c-.12,0-3.05-.18-4.58,1.72a.44.44,0,0,0,.06.61Z",
    fill: "#263238",
    style: {
      transformOrigin: "329.413px 108.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M341.32,109.09a.43.43,0,0,0,.26-.79,4.31,4.31,0,0,0-3.9-.55.44.44,0,0,0-.23.57.43.43,0,0,0,.57.23,3.42,3.42,0,0,1,3.08.47A.44.44,0,0,0,341.32,109.09Z",
    fill: "#263238",
    style: {
      transformOrigin: "339.597px 108.301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "372.74 406.79 381.95 406.35 379.22 385.55 370.02 386",
    fill: "#ffc3bd",
    style: {
      transformOrigin: "375.985px 396.17px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.2,
    style: {
      transformOrigin: "375.32px 391.14px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "379.22 385.56 380.63 396.28 371.42 396.72 370.01 386",
    style: {
      transformOrigin: "375.32px 391.14px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m349.75 199.77s11.59 70.25 16.31 97.64c4.92 28.48 16 95.51 16 95.51l-12.18 2s-16.42-67.1-23-95c-7.14-30.45-24.44-71.28-24.26-100.07z",
    fill: "#16A085",
    style: {
      transformOrigin: "352.339px 297.345px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m331.14 221.33c-1.74-2.53-5.09-6.08-7.66-9 2.33 17.9 9 38.67 15.09 58.23 1.62-14.9 0.7-37.5-7.43-49.23z",
    opacity: 0.2,
    style: {
      transformOrigin: "331.358px 241.445px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "315.92 405.38 325.04 405.38 325.65 384.26 316.52 384.26",
    fill: "#ffc3bd",
    style: {
      transformOrigin: "320.785px 394.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M325.47,404H315.22a.73.73,0,0,0-.73.63l-1.17,8.1a1.48,1.48,0,0,0,1.47,1.63c3.57-.07,5.29-.28,9.8-.28,2.77,0,8.5.29,12.33.29s4-3.78,2.44-4.13c-7.15-1.53-10-3.65-12.37-5.68A2.4,2.4,0,0,0,325.47,404Z",
    fill: "#263238",
    style: {
      transformOrigin: "326.798px 409.185px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.2,
    style: {
      transformOrigin: "320.925px 389.715px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "325.64 384.27 325.33 395.16 316.21 395.16 316.52 384.27",
    style: {
      transformOrigin: "320.925px 389.715px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M339.34,199.77s-3.7,71.15-6.2,98.85c-2.61,28.82-5.75,94.13-5.75,94.13H315.05s-2.2-65.06-1.34-93.48c.93-31-6.52-70.71-1.49-99.5Z",
    fill: "#16A085",
    style: {
      transformOrigin: "324.9px 296.26px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "313.98 393.19 328.45 393.46 328.67 384.64 313.92 385.56",
    fill: "#263238",
    style: {
      transformOrigin: "321.295px 389.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M328.89,405.63a3.42,3.42,0,0,0,2.21-.56,1.2,1.2,0,0,0,.39-1.06.7.7,0,0,0-.36-.57c-1.12-.62-4.76,1.24-5.17,1.46a.22.22,0,0,0-.11.22.21.21,0,0,0,.17.18A15.11,15.11,0,0,0,328.89,405.63Zm1.63-1.89a.92.92,0,0,1,.4.08.26.26,0,0,1,.14.23.74.74,0,0,1-.25.69c-.55.5-2.05.59-4.07.25A11.69,11.69,0,0,1,330.52,403.74Z",
    fill: "#16A085",
    style: {
      transformOrigin: "328.675px 404.479px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M326.06,405.31l.09,0c1.09-.49,3.24-2.46,3.07-3.49,0-.25-.21-.55-.81-.61a1.56,1.56,0,0,0-1.2.37c-1.14.95-1.35,3.41-1.36,3.51a.22.22,0,0,0,.09.2A.25.25,0,0,0,326.06,405.31Zm2.18-3.7h.13c.39,0,.42.19.42.25.11.62-1.35,2.16-2.46,2.83a5,5,0,0,1,1.16-2.81A1.13,1.13,0,0,1,328.24,401.61Z",
    fill: "#16A085",
    style: {
      transformOrigin: "327.539px 403.255px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M381.84,404H371.59a.56.56,0,0,0-.59.63l.52,8.1a1.89,1.89,0,0,0,1.8,1.63c3.56-.07,5.24-.28,9.74-.28,2.78,0,8.57.29,12.4.29s3.24-3.78,1.58-4.13c-7.47-1.53-10.73-3.65-13.56-5.68A2.89,2.89,0,0,0,381.84,404Z",
    fill: "#263238",
    style: {
      transformOrigin: "384.661px 409.184px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M385.26,405.63a3.45,3.45,0,0,0,2.22-.56,1.22,1.22,0,0,0,.39-1.06.71.71,0,0,0-.37-.57c-1.12-.62-4.75,1.24-5.16,1.46a.22.22,0,0,0-.12.22.23.23,0,0,0,.17.18A15.11,15.11,0,0,0,385.26,405.63Zm1.63-1.89a.86.86,0,0,1,.4.08.27.27,0,0,1,.15.23.79.79,0,0,1-.25.69c-.56.5-2.06.59-4.08.25A11.77,11.77,0,0,1,386.89,403.74Z",
    fill: "#16A085",
    style: {
      transformOrigin: "385.049px 404.479px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M382.44,405.31l.09,0c1.08-.49,3.23-2.46,3.06-3.49,0-.25-.21-.55-.81-.61a1.54,1.54,0,0,0-1.19.37c-1.15.95-1.36,3.41-1.37,3.51a.25.25,0,0,0,.09.2A.28.28,0,0,0,382.44,405.31Zm2.17-3.7h.13c.39,0,.42.19.43.25.1.62-1.36,2.16-2.47,2.83a5.06,5.06,0,0,1,1.16-2.81A1.15,1.15,0,0,1,384.61,401.61Z",
    fill: "#16A085",
    style: {
      transformOrigin: "383.91px 403.255px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "368.86 395.49 383.15 393.19 381.54 385.55 367.38 388.89",
    fill: "#263238",
    style: {
      transformOrigin: "375.265px 390.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m330.57 112.49 1.71-0.67s-0.77 1.46-1.71 0.67z",
    fill: "#263238",
    style: {
      transformOrigin: "331.425px 112.272px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M312.15,197.6l-.94,3.32c-.13.25.17.52.6.52h38.12c.34,0,.61-.17.63-.38l.34-3.31c0-.23-.27-.43-.63-.43H312.76A.68.68,0,0,0,312.15,197.6Z",
    fill: "#263238",
    style: {
      transformOrigin: "331.04px 199.379px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M317.32,201.79h-1c-.2,0-.35-.1-.34-.22l.47-4.31c0-.13.19-.23.39-.23h1c.2,0,.35.1.34.23l-.48,4.31C317.69,201.69,317.52,201.79,317.32,201.79Z",
    fill: "#16A085",
    style: {
      transformOrigin: "317.08px 199.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M347.11,201.79h-1c-.2,0-.36-.1-.34-.22l.47-4.31c0-.13.19-.23.39-.23h1c.2,0,.35.1.34.23l-.47,4.31C347.48,201.69,347.31,201.79,347.11,201.79Z",
    fill: "#16A085",
    style: {
      transformOrigin: "346.869px 199.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M332.27,201.79h-1c-.2,0-.35-.1-.34-.22l.47-4.31c0-.13.19-.23.39-.23h1c.2,0,.35.1.33.23l-.47,4.31C332.65,201.69,332.47,201.79,332.27,201.79Z",
    fill: "#16A085",
    style: {
      transformOrigin: "332.026px 199.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m320.27 142.09c-5.81 0.53-14.69-0.57-14.42 8.34s-1.46 32.51-1 43.56-2.42 82.6 2.24 103.34c0.82 3.65 30.92 3.18 34.56 2.83v-3.29s21.87-2.94 27.28-2c-0.47-12.46-12.58-75.4-13.05-93.08s1.52-48.06 1.4-52.88-9.7-6.94-15.57-6.82c1.3 4.35-1.57 12.52-6.16 21.63-11.29-11-14.62-16.46-15.28-21.63z",
    fill: "#16A085",
    style: {
      transformOrigin: "336.658px 221.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m320.27 142.09c-5.81 0.53-14.69-0.57-14.42 8.34s-1.46 32.51-1 43.56-2.42 82.6 2.24 103.34c0.82 3.65 30.92 3.18 34.56 2.83v-3.29s21.87-2.94 27.28-2c-0.47-12.46-12.58-75.4-13.05-93.08s1.52-48.06 1.4-52.88-9.7-6.94-15.57-6.82c1.3 4.35-1.57 12.52-6.16 21.63-11.29-11-14.62-16.46-15.28-21.63z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      transformOrigin: "336.658px 221.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m309.21 163.22-3.72 2.63c-0.29 7.7-0.68 16.33-0.72 23 3.46-7.65 5.41-18.69 4.44-25.63z",
    fill: "#16A085",
    opacity: 0.2,
    style: {
      transformOrigin: "307.114px 176.035px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M321.06,155.23a9.53,9.53,0,0,1-.61.81l-.21.24-.11.12-.2.21-.4.43-.8.89c-.54.59-1.06,1.2-1.58,1.82q-1.56,1.86-3,3.79a92.79,92.79,0,0,0-5.47,8,52.05,52.05,0,0,0-7.06,16.65,28.14,28.14,0,0,0-.47,4,5.09,5.09,0,0,0,.57,1.91,46,46,0,0,0,4.56,7.64c1.85,2.64,3.95,5.21,6.1,7.75,1.08,1.28,2.2,2.52,3.33,3.75s2.31,2.49,3.41,3.58l-10.78,10.42c-1.31-1.43-2.47-2.73-3.68-4.1l-3.53-4.13c-2.34-2.77-4.59-5.65-6.81-8.67a59.69,59.69,0,0,1-6.22-10.22,28,28,0,0,1-1.29-3.44,17.27,17.27,0,0,1-.49-2.13,11.19,11.19,0,0,1-.16-1.25,12.37,12.37,0,0,1-.05-1.32,43.17,43.17,0,0,1,.55-6.41A56.87,56.87,0,0,1,290,173.88a87.81,87.81,0,0,1,5-10.38c1.84-3.3,3.86-6.45,5.95-9.53,1.06-1.54,2.14-3.05,3.27-4.54l1.71-2.23.89-1.12.45-.56.23-.27.1-.13,0,0v0l-.14.16c-.18.23-.35.46-.51.7Z",
    fill: "#16A085",
    style: {
      transformOrigin: "303.584px 186.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M321.06,155.23a9.53,9.53,0,0,1-.61.81l-.21.24-.11.12-.2.21-.4.43-.8.89c-.54.59-1.06,1.2-1.58,1.82q-1.56,1.86-3,3.79a92.79,92.79,0,0,0-5.47,8,52.05,52.05,0,0,0-7.06,16.65,28.14,28.14,0,0,0-.47,4,5.09,5.09,0,0,0,.57,1.91,46,46,0,0,0,4.56,7.64c1.85,2.64,3.95,5.21,6.1,7.75,1.08,1.28,2.2,2.52,3.33,3.75s2.31,2.49,3.41,3.58l-10.78,10.42c-1.31-1.43-2.47-2.73-3.68-4.1l-3.53-4.13c-2.34-2.77-4.59-5.65-6.81-8.67a59.69,59.69,0,0,1-6.22-10.22,28,28,0,0,1-1.29-3.44,17.27,17.27,0,0,1-.49-2.13,11.19,11.19,0,0,1-.16-1.25,12.37,12.37,0,0,1-.05-1.32,43.17,43.17,0,0,1,.55-6.41A56.87,56.87,0,0,1,290,173.88a87.81,87.81,0,0,1,5-10.38c1.84-3.3,3.86-6.45,5.95-9.53,1.06-1.54,2.14-3.05,3.27-4.54l1.71-2.23.89-1.12.45-.56.23-.27.1-.13,0,0v0l-.14.16c-.18.23-.35.46-.51.7Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      transformOrigin: "303.584px 186.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m335.56 163.72c1.05 21.34 6.75 95.76 6.1 133.15l1.74-0.23s-2.7-57.5-3.92-82.66-3.92-50.26-3.92-50.26z",
    fill: "#16A085",
    opacity: 0.3,
    style: {
      transformOrigin: "339.48px 230.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m318.28 217-10.68 11.56c0 3.88-2.71 11.64 4.47 14.46s7.37-17.64 6.21-26.02z",
    fill: "#16A085",
    opacity: 0.3,
    style: {
      transformOrigin: "312.956px 230.142px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m353.1 216.64 4.7 11.78c0.14 4 1.51 12-1.27 15.05s-3.59-18.16-3.43-26.83z",
    fill: "#16A085",
    opacity: 0.3,
    style: {
      transformOrigin: "355.671px 230.204px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M341.43,171.15l11.73-.08a.81.81,0,0,0,.84-.9l-.65-5.56a1.06,1.06,0,0,0-1-.89l-11.74.07a.82.82,0,0,0-.84.9l.65,5.57A1.07,1.07,0,0,0,341.43,171.15Z",
    fill: "#fff",
    stroke: "#16A085",
    strokeMiterlimit: 10,
    strokeWidth: ".5px",
    style: {
      transformOrigin: "346.886px 167.435px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroupier);
export default __webpack_public_path__ + "static/media/croupier.74ea95c1884189bb8e9bd18a824cea2f.svg";
export { ForwardRef as ReactComponent };